import React from 'react'

export function LoaderWhiteBtn() {
  return (
    <div
      style={{
        display: 'block',
      }}
    >
      <div
        style={{
       
          animation: '400ms linear infinite anim-rotate',

          borderBottom: '2px solid #d3014c',

          borderLeft: '2px solid #d3014c',

          borderRadius: '50%',

          borderRight: '2px solid transparent',

          borderTop: '2px solid #fff',

          boxSizing: 'border-box',

          height: 20,

          width: 20,

          marginLeft: 5,

          marginRight: 5,

          display: 'block',


        }}
      />
    </div>
  )
}

